import { ethResolveStringParameter } from "@blockwell/eth-types";
import { delay } from "@blockwell/util";
import { findEvents, getTokenData } from "./util";
import { bwTypeMap } from "@blockwell/apiminer-client";
export class DeployedExtraProcessor {
    constructor() {
        this.key = "deployed";
    }
    async process(parameters, submission) {
        let deployed = [];
        for (let { event, step } of findEvents(submission, /Deployed/)) {
            let address = ethResolveStringParameter(event.params, "contractAddress");
            if (address) {
                try {
                    // Try 3 times in case there's delay in propagation
                    for (let i = 0; i < 3; i++) {
                        let contract = await getTokenData(parameters.contracts, step.network, address);
                        if (contract?.bwtype) {
                            let type = bwTypeMap[contract.bwtype];
                            if (type) {
                                let dep = {
                                    ...contract,
                                };
                                if (type.happ) {
                                    dep.happ = `/${type.happ}?net=${dep.network}&contract=${dep.address}`;
                                }
                                deployed.push(dep);
                            }
                            break;
                        }
                        else {
                            await delay(3000);
                        }
                    }
                }
                catch (err) {
                    console.error(err);
                }
            }
        }
        return deployed;
    }
}
